import { useEffect, useState } from "react";
import './overview.css'
import { useNavigate } from 'react-router-dom';

function BillingOverview({ userInfo, billingData, subscriptionDetail }) {

    console.log(billingData)
    console.log(subscriptionDetail)

    const navigate = useNavigate();

    function goToPage(path) {
        navigate(path);
    }

    const options = { month: 'short', day: 'numeric' };

    return (
        <div>
            {(billingData && subscriptionDetail) ?
                <div className="billing_overview_main_div">
                    <div className="flex flex_column gap_12">
                        <p className="font_weight_600 font_size_20">Hello {userInfo.first_name},</p>
                        {subscriptionDetail.status === "active" || subscriptionDetail.status === "trialing" ?
                            <p className="font_size_16">Thank you for being a Premium member</p>
                            : subscriptionDetail.status === "canceled" ?
                                <p className="font_size_16">We're sorry that you are leaving.</p>
                                : null}
                    </div>


                    {subscriptionDetail.status === "active" || subscriptionDetail.status == "trialing" ?
                        <p className="billing_overview_membership_p gray_scale_2">Premium membership: ${subscriptionDetail.plan.amount / 100}/{billingData.plan_type == 'Monthly subscription' ? 'mo' : 'yr'}</p>
                        : null}

                    {subscriptionDetail.status === "active" ?
                        <div className="billing_overview_next_payment_div flex flex_column justify_space_between gap_12">
                            <div className="billing_overview_next_payment_date flex gap_12">
                                <p className="font_size_16">Next Billing Date:</p>
                                <p className="font_size_16">{new Date(subscriptionDetail.current_period_end * 1000).toLocaleDateString('en-US', options)}</p>
                            </div>

                            <a href="/billing/cancel" className="billing_overview_cancel_subscription cursor_pointer text_decoration_none flex align_center justify_center">Cancel Plan</a>
                        </div>
                        : subscriptionDetail.status === "trialing" ?
                            <div className="billing_overview_next_payment_div flex flex_column justify_space_between gap_12">
                                <div className="billing_overview_next_payment_date flex gap_12">
                                    <p className="font_size_16">Billing starts from:</p>
                                    <p className="font_size_16">{new Date(subscriptionDetail.current_period_end * 1000).toLocaleDateString('en-US', options)}</p>
                                </div>

                                <a href="/billing/cancel" className="billing_overview_cancel_subscription cursor_pointer text_decoration_none flex align_center justify_center">Cancel Plan</a>
                            </div>
                            : subscriptionDetail.status === "canceled" ?
                                <div className="billing_overview_next_payment_div flex justify_space_between align_center gap_12">
                                    <div className="billing_overview_next_payment_date flex gap_12">
                                        <p className="font_size_16">Your premium plan will end on:</p>
                                        <p className="font_size_16">{new Date(subscriptionDetail.current_period_end * 1000).toLocaleDateString('en-US', options)}</p>
                                    </div>

                                    <span className="billing_overview_reactivate_button cursor_pointer text_decoration_none font_size_16" onClick={() => {
                                        goToPage('/premium')
                                    }} >
                                        Restore
                                    </span>
                                </div>
                                : null}
                </div>
                :
                (billingData && billingData.payment_provider_fk == 1) ?
                    <div className="billing_overview_main_div">
                        <div className="flex flex_column gap_12">
                            <p className="font_weight_600 font_size_20">Hello {userInfo.first_name},</p>
                            <p className="font_size_16">Thank you for being a Premium member</p>
                        </div>

                        <p className="billing_overview_membership_p gray_scale_2">Premium membership: ${billingData.price}/{billingData.plan_type == 'Monthly subscription' ? 'mo' : 'yr'}</p>


                        <div className="width_fit_content">
                            <a href={'https://www.apple.com/in/app-store/'} target="_blank" className="text_decoration_none ">
                                <p className="billing_overview_reactivate_button cursor_pointer text_decoration_none font_size_16 width_fit_content">Visit App Store</p>
                            </a>
                        </div>
                        <br />
                        <p className="italic ">You can manage your subscription through the App Store</p>
                    </div>
                    :
                    userInfo ?
                        <div>
                            <div className="flex flex_column gap_8">
                                <p className="font_weight_600 font_size_20">Hello {userInfo.first_name},</p>
                                <p className="font_size_16">Become a Premium member and gain access to all the unlimited features that we offer.</p>
                            </div>
                            <button className='billing_overview_go_premium cursor_pointer font_size_16 font_weight_600' onClick={() => goToPage('/premium')}>Go Premium</button>
                        </div>
                        : null
            }
        </div>
    );
}


export default BillingOverview;